import { useQuery } from '@tanstack/react-query';

import { listHarnessTypes } from '@/lib/api/generated/api';

import { harnessTypeKeys } from '../queryKeys';
import type { HarnessType } from '../types';

/**
 * The harness types this deployment lists, in the backend's order.
 *
 * The list changes only when the deployment does, so it is cached for a long
 * time and never polled. Anything but a 200 throws, so a caller can tell "no
 * types" from "could not find out" and offer a retry instead of a guessed list.
 */
export function useHarnessTypes() {
  const query = useQuery({
    queryKey: harnessTypeKeys.list(),
    queryFn: async (): Promise<HarnessType[]> => {
      const response = await listHarnessTypes();
      if (response.status !== 200) {
        throw new Error('The harness types could not be loaded.');
      }
      return response.data.items;
    },
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  return {
    types: query.data,
    isPending: query.isPending,
    loadFailed: query.isError,
    refetch: query.refetch,
  };
}
